import {
    bigQueryListener,
    mixpanelListener,
    loggerListener,
    statsListener,
    biankaListener,
    LogLevel,
    ListenerMode,
} from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { getMetaTagValue } from '@fiverr-private/layout_lib/getMetaTagValue';
import {
    META_TAG_NAME_LOG_LEVEL,
    META_TAG_NAME_FACILITY,
    META_TAG_NAME_PAGE_NAME,
    META_TAG_NAME_CTX_ID,
    META_TAG_NAME_CREATION_TIME,
    META_TAG_NAME_USER_ID,
    META_TAG_NAME_U_GUID,
} from '@fiverr-private/layout_constants';
import { EXPERIMENTS } from '@fiverr-private/layout-abtests';
import { mandatoryScriptLoggerInterceptor } from './mandatoryScriptLoggerInterceptor';

declare global {
    interface Window {
        brazeContext?: {
            brazeExternalUserId?: string;
        };
    }
}
/**
 * Initialize OBS listeners using existing DOM metatags.
 */

const mode = getMetaTagValue('app_environment') as ListenerMode;
const logLevel = getMetaTagValue(META_TAG_NAME_LOG_LEVEL) as LogLevel;
const facility = getMetaTagValue(META_TAG_NAME_FACILITY) as string;
const pageName = getMetaTagValue(META_TAG_NAME_PAGE_NAME) as string;
const biankaUrl = getMetaTagValue('browser_bianka_api') as string;
const relay = getMetaTagValue('browser_stats_api_v1');
const relayAPI = getMetaTagValue('browser_relay_service_api');
const mixpanelToken = getMetaTagValue('gtm:mixpanel_token');
const { countryCode, abTests = {} } = getContext();
const inAntsMixpanelSessionRecordingRollout = Number(abTests[EXPERIMENTS.ANTS_MIXPANEL_SESSION_RECORDING]) === 2;

const getMixpanelRecordSessionPercent = () => {
    if (['PK', 'IN', 'ID', 'BD', 'NG', 'MY', 'MA'].includes(countryCode)) return 0;
    return inAntsMixpanelSessionRecordingRollout ? 100 : 0.5;
};

loggerListener({
    host: relayAPI,
    mode,
    logLevel,
})
    .setEnricher(() => ({
        page: {
            ctx: getMetaTagValue(META_TAG_NAME_CTX_ID),
            name: pageName,
            url: document.location.href,
            referrer: document.referrer || undefined,
            creation: getMetaTagValue(META_TAG_NAME_CREATION_TIME),
        },
        user: {
            id: getMetaTagValue(META_TAG_NAME_USER_ID),
            uid: getMetaTagValue(META_TAG_NAME_U_GUID),
        },
    }))
    .intercept(mandatoryScriptLoggerInterceptor);

bigQueryListener({
    host: '/api/v1/activities',
    facility,
    mode,
});

mixpanelListener({
    token: mixpanelToken,
    recordHeatmapData: true,
    recordSessionPercent: getMixpanelRecordSessionPercent(),
    mode,
    userId: getContext().userId,
    userGuid: getContext().userGuid,
    brazeExternalUserId: window?.brazeContext?.brazeExternalUserId || undefined,
});

statsListener({
    host: relay,
    mode,
});

biankaListener({
    pageName,
    mode,
    facility,
    baseUrl: biankaUrl,
}).setEnricher(() => {
    const { userId, locale, userGuid, pageCtxId } = getContext();
    return {
        userId,
        locale,
        uid: userGuid,
        hostname: window.location.hostname,
        page: {
            ctxId: pageCtxId,
        },
    };
});
